import React from "react";
import PropertyInventoryPage from "./propertyInventory.jsx";

function Main() {
  return <PropertyInventoryPage propertyId="Main" />;
}

export default Main;
